<div class="mwp-modal">
  <div class="modal-header w-100 d-flex align-items-center">
    <span>{{ title }}</span>
  </div>
  <div class="modal-has-controls">
    <div class="p-3">
      <div class="message-container blue-fill">
        <div class="mb-2">
          <mwp-text-translate text="Dependent's demographic information (first name, last name, relationship, gender, and date-of-birth are required)." jsonKey="dependentDialogInfo" />
        </div>
        <div>
          <mwp-text-translate text="Social security number is optional, though highly recommended." jsonKey="dependentDialogInfo2" />
        </div>
      </div>
    </div>
    @if (coverageAddDependent?.unqualifiedDependents) {
      <div class="modal-note mb-5">
        <mwp-text-translate text="Please note, following dependents are under file but ineligible under your chosen plan/s. If you would like to learn more why this may be, please read the resources or contact your administrator." jsonKey="dependentDialogNote" />
        <div>
          <mwp-table [tableColumns]="unqualifiedDependentsColumns" [dataSource]="unqualifiedDependentsMatData" />
        </div>
      </div>
    }
    @if (error) {
      <div class="error">
        {{ error }}
      </div>
    }
    <div>
      @if (displayForm) {
        <mwp-dependent-form [isNewDependent]="isNewDependent" [isChangeSaveToContinue]="$safeNavigationMigration(coverageAddDependent?.showTobaccoQuestion)" [dependent]="dependent" (emitContinueForm)="dependentTobaccoQuestion($event)" (emitDependent)="saveDependent($event)" (emitClose)="closeDialog()" />
      }
      @if (displayTobaccoQuestion) {
        <mwp-benefit-enrollment-wizard-tobacco-usage [hideWizardControl]="true" [tobaccoModel]="tobaccoModel" (emitBack)="tobaccoBack()" (emitCancel)="closeDialog()" (emitComplete)="saveTobaccoDependent($event)" />
      }
    </div>
  </div>
</div>